import { Col, Row } from 'antd';
import React, { ReactElement, useEffect } from 'react';
import { HOSPITAL_PROFILE_NESTED_ROUTE } from '../../../config/route/NestedRoutesConfig';
import CommonTab from '../../../shared/components/tabs/CommonTab';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { getMappedRoute } from '../../../utils/routeUtility';
import '../../../assets/styles/customAntTab.less';
import Contact from '../contact/Contact';
import { GUTTOR_SPACE, REQUEST_PAYLOAD } from '../../../shared/constants/commonConstants';
import PageHeader from '../../../shared/components/pageHeader/PageHeader';
import { FETCH_DASHBOARD } from '../../../shared/constants/urlEndPoints';
import { useDispatch, useSelector } from 'react-redux';
import { dashBoardRequest } from '../../../store/actions/leftSideBarAction';
import { PROFILE_CONSTANTS } from './../../../shared/constants/commonConstants';
import ApplicationDetail from './../../../shared/services/applicationDetail.service';
import { fetchHospitalProfile } from '../../../store/actions/hospitalAction';
import { GetFirstElement } from '../../../utils/utility';

const Profile = ({ match, location }: any): ReactElement => {
  const dispatch = useDispatch();
  const hospitalProfileData = useSelector(({ hospital: { hospitalProfile } }: any): any => hospitalProfile);

  useEffect((): void => {
    localStorage?.removeItem('FileUploadType');
    if (!hospitalProfileData || (hospitalProfileData && !GetFirstElement(hospitalProfileData)?.registrationDetails) ||
      (hospitalProfileData && !GetFirstElement(hospitalProfileData)?.bankDetails) ||
      (hospitalProfileData && !GetFirstElement(hospitalProfileData)?.contactDetails)) {
      getHospitalProfile();
    }
    dispatch(dashBoardRequest({
      title: PROFILE_CONSTANTS.hospitalProfile,
      url: `${process.env.REACT_APP_BASE_URL}${FETCH_DASHBOARD}`, type: PROFILE_CONSTANTS.profile,
    }));
    // eslint-disable-next-line
  }, []);

  const getHospitalProfile = (): void => {
    dispatch(fetchHospitalProfile(REQUEST_PAYLOAD));
  };

  const nextDefaultPage =
    getMappedRoute(location?.pathname, HOSPITAL_PROFILE_NESTED_ROUTE) ||
    HOSPITAL_PROFILE_NESTED_ROUTE[0].routeName;

  return (
    <>
      <PageHeader colSize={18}
        pageTitle={ApplicationDetail.instance.getHospitalDetail()?.providerName}
      />
      <div className="ant-tabs-content-holder tab-custom-container width-class">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={16} className="custom-ant-tab">
            <NestedRoute
              tabType="card-profile"
              match={match}
              defaultPage={nextDefaultPage}
              nestedNav={HOSPITAL_PROFILE_NESTED_ROUTE}
              commonComponent={CommonTab}
            />
          </Col>
          <Col md={8}>
            <Contact />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Profile;
